import { render, staticRenderFns } from "./panelLateral.vue?vue&type=template&id=3d153124"
import script from "./panelLateral.vue?vue&type=script&lang=js"
export * from "./panelLateral.vue?vue&type=script&lang=js"
import style0 from "./panelLateral.vue?vue&type=style&index=0&id=3d153124&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports